/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.CustomerDropdownFilter = (function() {

    /**
     * Namespace CustomerDropdownFilter.
     * @exports CustomerDropdownFilter
     * @namespace
     */
    var CustomerDropdownFilter = {};

    CustomerDropdownFilter.CustomerDropdownFilterModel = (function() {

        /**
         * Properties of a CustomerDropdownFilterModel.
         * @memberof CustomerDropdownFilter
         * @interface ICustomerDropdownFilterModel
         * @property {string|null} [name] CustomerDropdownFilterModel name
         * @property {number|null} [pageIndex] CustomerDropdownFilterModel pageIndex
         * @property {number|null} [pageSize] CustomerDropdownFilterModel pageSize
         */

        /**
         * Constructs a new CustomerDropdownFilterModel.
         * @memberof CustomerDropdownFilter
         * @classdesc Represents a CustomerDropdownFilterModel.
         * @implements ICustomerDropdownFilterModel
         * @constructor
         * @param {CustomerDropdownFilter.ICustomerDropdownFilterModel=} [p] Properties to set
         */
        function CustomerDropdownFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * CustomerDropdownFilterModel name.
         * @member {string|null|undefined} name
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        CustomerDropdownFilterModel.prototype.name = null;

        /**
         * CustomerDropdownFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        CustomerDropdownFilterModel.prototype.pageIndex = null;

        /**
         * CustomerDropdownFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        CustomerDropdownFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * CustomerDropdownFilterModel _name.
         * @member {"name"|undefined} _name
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        Object.defineProperty(CustomerDropdownFilterModel.prototype, "_name", {
            get: $util.oneOfGetter($oneOfFields = ["name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CustomerDropdownFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        Object.defineProperty(CustomerDropdownFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * CustomerDropdownFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @instance
         */
        Object.defineProperty(CustomerDropdownFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified CustomerDropdownFilterModel message. Does not implicitly {@link CustomerDropdownFilter.CustomerDropdownFilterModel.verify|verify} messages.
         * @function encode
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @static
         * @param {CustomerDropdownFilter.ICustomerDropdownFilterModel} m CustomerDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDropdownFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(10).string(m.name);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(16).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(24).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified CustomerDropdownFilterModel message, length delimited. Does not implicitly {@link CustomerDropdownFilter.CustomerDropdownFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @static
         * @param {CustomerDropdownFilter.ICustomerDropdownFilterModel} message CustomerDropdownFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomerDropdownFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomerDropdownFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {CustomerDropdownFilter.CustomerDropdownFilterModel} CustomerDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDropdownFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.CustomerDropdownFilter.CustomerDropdownFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = r.string();
                    break;
                case 2:
                    m.pageIndex = r.int32();
                    break;
                case 3:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a CustomerDropdownFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof CustomerDropdownFilter.CustomerDropdownFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {CustomerDropdownFilter.CustomerDropdownFilterModel} CustomerDropdownFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomerDropdownFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return CustomerDropdownFilterModel;
    })();

    return CustomerDropdownFilter;
})();

module.exports = $root;
